export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "exportation": {
            "booking_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "booking_code_0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Booking"])},
            "booking_code_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Air Waybill"])},
            "origin_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Origen"])},
            "destination_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destino"])},
            "departured_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salida"])},
            "arrived_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Llegada"])},
            "shipping_line": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transportista"])},
            "ship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nave"])},
            "dam_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DAM"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semana"])},
            "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
            "exportation_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo"])},
            "containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
            "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
            "exportation_attachments": {
              "exporter_process_exportation_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de adjunto"])},
              "exportation_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjunto"])}
            },
            "intermediated_agro_exporter_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agroexportadora"])}
          }
        }
      },
      "en": {
        "model": {
          "exportation": {
            "booking_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
            "booking_code_0": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Booking"])},
            "booking_code_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Air Waybill"])},
            "origin_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Origin"])},
            "destination_export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destination"])},
            "departured_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Departure"])},
            "arrived_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arrival"])},
            "shipping_line": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carrier"])},
            "ship": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ship"])},
            "dam_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DAM"])},
            "week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Week"])},
            "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
            "exportation_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Types"])},
            "containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])},
            "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])},
            "intermediated_organization_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organization"])}
          }
        }
      }
    }
  })
}